import { z } from 'zod';
export const SendToBringSchema = z.object({
    servings: z.number().int().min(1).max(50),
    ingredientIds: z.array(z.string()).default([]),
});
export const SendToBringResponseSchema = z.object({
    sent: z.array(z.object({
        name: z.string(),
        specification: z.string(),
    })),
    failed: z.array(z.object({
        name: z.string(),
        reason: z.string(),
    })),
});
export const HealthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    bring: z.enum(['connected', 'disconnected']),
    version: z.string().optional(),
});
export const ApiEnvelope = (dataSchema) => z.object({
    data: dataSchema.nullable(),
    error: z
        .object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    })
        .nullable(),
});
//# sourceMappingURL=bring.js.map